import { TableCell, TableRow } from '@mui/material'

export default function NoOwnersRow(props) {
    const { key } = props
    return <TableRow key={key}>
        <TableCell colSpan={4} align="center" sx={{ width: "100%" }}>No franchise owners found</TableCell>
    </TableRow>
}
